import { render } from "./ManagerCriticalEvents.vue?vue&type=template&id=24907f6a"
import script from "./ManagerCriticalEvents.vue?vue&type=script&lang=js"
export * from "./ManagerCriticalEvents.vue?vue&type=script&lang=js"

import "./ManagerCriticalEvents.vue?vue&type=style&index=0&id=24907f6a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__